import { isMascotColor, type MascotConfig } from './mascot-catalog'

export function mixMascotColor(color: string, target: string, amount: number) {
  const base = isMascotColor(color) ? color : '#cb945d'
  return (
    '#' +
    [1, 3, 5]
      .map((index) => {
        const from = parseInt(base.slice(index, index + 2), 16)
        const to = parseInt(target.slice(index, index + 2), 16)
        return Math.round(from + (to - from) * amount)
          .toString(16)
          .padStart(2, '0')
      })
      .join('')
  )
}

export function mascotSceneColor(config: MascotConfig) {
  const themes = {
    classic: '#dbe8d5',
    meadow: '#c4dfb8',
    sunset: '#efc3b0',
    clouds: '#c8e0ee',
    stars: '#9cabc9',
    jungle: '#4b775a',
    farm: '#c7dfdb',
  }
  return config.sceneColor ?? themes[config.backdrop ?? 'classic']
}

export function mascotFurPalette(color: string) {
  return {
    mid: color,
    light: mixMascotColor(color, '#ffffff', 0.38),
    shade: mixMascotColor(color, '#352b32', 0.34),
    ear: mixMascotColor(color, '#59433f', 0.27),
    cream: mixMascotColor(color, '#fff8ed', 0.82),
    pattern: mixMascotColor(color, '#282131', 0.53),
  }
}
